const DEFAULT_TAG_ID = "AW-1065576391";
const CONVERSION_LABELS = {
    "contact_form": "jApWCKL-2ZwdEMfPjfwD"
};

class GoogleTag {
    constructor(tagId = DEFAULT_TAG_ID) {
        this.tagId = tagId;
    }

    isInjected() {
        return document.querySelector('script[src*="gtag/js?id=' + this.tagId + '"]') !== null;
    }

    inject() {
        if (!this.tagId || this.isInjected()) {
            return;
        }

        const script = document.createElement('script');
        script.src = 'https://www.googletagmanager.com/gtag/js?id=' + this.tagId;
        script.async = true;

        document.head.appendChild(script);

        this.push('js', new Date());
        this.push('config', this.tagId);
    }

    trackConversion(conversionName) {
        const label = CONVERSION_LABELS[conversionName];
        if (!this.tagId || !label) {
            return;
        }

        this.inject();
        this.push('event', 'conversion', { 'send_to': this.tagId + '/' + label });
    }

    push() {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(arguments);
    }
}

export default GoogleTag;
